import OapBeautyGeniusCard from './code/Scripts/components/OapBeautyGeniusCard.vue';
import OapBeautyGeniusCardExpandedInGrid from './code/Scripts/components/OapBeautyGeniusCardExpandedInGrid.vue';

export default {
  components: {
    OapBeautyGeniusCard,
    OapBeautyGeniusCardExpandedInGrid,
  },
};
